/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    GUEST_ACCESS_BR16_ADMIN_VISITORS
 * Date:         2026-07-06
 * Modified By:  Engineering
 *
 * Description:
 * Page wrapper for the admin Visitors (guest activity) screen.
 */

import React from "react";
import GuestVisitors from "../../features/admin/visitors/GuestVisitors";

const GuestVisitorsPage: React.FC = () => {
  return <GuestVisitors />;
};

export default GuestVisitorsPage;
